import React, { useEffect, useRef } from "react";
import { useState } from "react";
import styled from "styled-components";
import { BottomSheet } from "react-spring-bottom-sheet";
import comment from "../assets/comment.png";
import like from "../assets/like.png";
import play from "../assets/play.svg";
import { useParams } from "react-router";
import { VIDEO_DETAILS } from "../constants/urls";
import ProfileDownloadIcon from "../components/mobile/ProfileDownloadIcon";
import FollowButtonProfilePic from "../components/mobile/FollowButtonProfilePic";
import Navbar from "../components/desktop/Navbar";
import VideoCard from "../components/desktop/VideoCard";
import BlueSticker from "../components/desktop/BlueSticker";
import DownloadBottomSheet from "../components/mobile/DownloadBottomSheet";
import { Swiper, SwiperSlide } from "swiper/react";
import "react-spring-bottom-sheet/dist/style.css";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import SwiperCore, { Pagination } from "swiper/core";
import Modal from "react-modal";
import BlueButton from "../components/desktop/BlueButton";
import Stories from 'react-insta-stories';
import stickers from '../assets/stickers.svg';
import square_cat from "../assets/glip_square.svg";
import input_bar from "../assets/input_bar.svg";
import meme_banner from "../assets/meme_banner.png";

let data = [    
    ['3,Photo,Moroccan Techie,https://yt3.ggpht.com/L8_7As7MY9B8ngZe23u9ohzpILKM7e6t7LAgmwk0ZXS8B4896vUiTd9dtps9YsT0x31aN2anvcoylLI=s800-nd-v1'],
    ['4,Video,Presented on a silver platter,https://www.youtube.com/watch?v=V1Sqyfy3CT4'],
    ['33,Photo,CEO Entrepreneur!,https://yt3.ggpht.com/bET03hB4rviUeA17ZI6QO2ePo6LlP_VZK-QQxI3Gj291NuSJ7BRLu2U5PY5XFuZTZiv81WlUrzeT=s641-nd-v1'],
    ['5,Text,Valorant mobile kab aaraha hai? @Riot,'],
    
    ['8,Photo,Thanks,https://yt3.ggpht.com/htIQZJBL5MdFOX_RXN64fJ_SnMj-sB7x8mHdE8CIY7PhWght8LHPMRnRJoQxNZ9ZDdNSPoNESxhfVw=s500-nd-v1-rwa'],
    ['9,Video,Calm down sage!,https://www.youtube.com/shorts/-LP302B0i1g'],
    ['10,Photo,"""Why didn\'t you call?""",https://yt3.ggpht.com/ByOuYN8L_ZUCncR76pf7Q4PZx5_BqD7yEXIz5qRUId1sT4JoTtTAB9rlu_q_Afrg3Hc2qTUkJqE7=s640-nd-v1'],
    ['11,Video,VALORANT Champions 2021: Format Explained,https://youtu.be/XwHOAlbHdvo'],
    ['12,Video,Valorant in a nutshell,https://www.youtube.com/shorts/M0IwzH-0vmo'],
    ['13,Text,Himanshi agar tum yeh padh rahi ho toh mujhe tumhein batana hai ki woh joh parso tumne sandwich khilaya tha mujhe uss se mujhe dast lag gayi hai. aage se kisi ko bhi sandwich mat khilana tu,'],
    ['14,Photo,Genius,https://yt3.ggpht.com/O3IxDL3xAL4L_VZnHXn7UTgIUQKfmGvRof2ossKEHREDmQV_vq069pPjt86ppHI2Uw12_h2VV2EJSkk=s640-nd-v1'],
    ['15,Video,SEN zombs Wins the Impossible,https://www.youtube.com/watch?v=G5eRVzC9YDQ&list=PLm3rRjSsa9GbkmO-zwnjOu56gKcclB712&index=5'],
    ['16,Video,Beautiful edit!,https://www.youtube.com/shorts/5HhR7BVqEDY'],
    ['17,Photo,Over 9000,https://yt3.ggpht.com/Ky85YjeKEO4vLSMpUUX_3a5gHaIT0wcL0jw_qg28qWhTqfnsdTSqBfyf0oV3fwy6EKZ9xz1VBdW1=s800-nd-v1'],
    ['18,Video,Sova 1v5 clutch,https://www.youtube.com/shorts/tLdVXA7uj-c'],
    ['19,Text,"Bhai. Yeh phoenix khelne waalon ne koi kasam le rakhi hai kya BC? Saala har game mein tum log aake team flash kyun karte ho. Faaltu logon, molly ko saamne waali team pe bhi phek sakte hain har baar khud pe nahi daalna hota. ",'],
    ['20,Video,Asuna is cracked,https://www.youtube.com/shorts/L4ZeDz6B8T0'],
    ['21,Photo,Time to roll,https://yt3.ggpht.com/KbPnhb3k5UaUcKTrsGnPNiLncS5-q4HCPZQtC6gAR-i7kVxSn7U7EOG9SoLREMKTJEqiA6HyoBW-WQ=s640-nd-v1-rwa'],
    ['22,Video,Killing Streamers With Sage Walls,https://www.youtube.com/watch?v=d_GecW1Lg_E&list=PLm3rRjSsa9GbkmO-zwnjOu56gKcclB712&index=2'],
    ['23,Photo,So cute!!,"https://yt3.ggpht.com/dnR426ANKu7GXpZDj-fnTyF0L9l23D_H52GxDPCup4zd30ow9esDCH8ku5HW80TUS3dxD6JViumXPw=s640-c-fcrop64=1,00001764ffffe89b-nd-v1"'],
    ['24,Video,How to clear showers on Bind,https://www.youtube.com/shorts/EFeMZYM9cV4'],
    ['25,Text,"Yeh waadiyan kuch alag si lagne lagi hain Aur badal gaya hai yeh nanga aasmaan, chahta hu pure dil se ki ek din duniya ko suna sakoo mai apni dard bhari daastaan (added) ",'],
    ['26,Photo,Yeh toh apna roz ka hai,https://yt3.ggpht.com/p6C4ZzrRSd2Gint_cdvnvuaMky1Z34qVe7nCw1VLFmq-kFKLmC02q9STrmWnjFkB_s3cXb0JICNjYcc=s511-nd-v1'],
    ['27,Video,200IQ Sova play,https://www.youtube.com/shorts/QsybgGzhcR8'],
    ['28,Video,Die For You VALORANT,https://www.youtube.com/watch?v=h7MYJghRWt0&list=PLm3rRjSsa9GbkmO-zwnjOu56gKcclB712&index=3'],
    ['29,Photo,I choose peace,https://yt3.ggpht.com/fpoyv_cn-Ej0vDUt5v4CBynlJfpBbuZsSOzpfApbFBPWwB7r7I8PkeesIkP0rmRaxgBrzey1PLXOl2A=s640-nd-v1'],
    ['30,Video,"""sup bois""",https://www.youtube.com/shorts/QbG9t3W43hI'],
    ['31,Photo,Simping time,https://yt3.ggpht.com/MznrpIoVmtIm_6hwSfy7SFXlpWZ_sle7jl5bw1tPJQ_6EMnMLV-iX1h_nrC5KCOFvc6VlRsZwInFHA=s640-nd-v1'],
    ['32,Video,Top 5 Best Moments Of SK ROSSI,https://www.youtube.com/watch?v=yCk5oRIIk7k&list=PLm3rRjSsa9GbkmO-zwnjOu56gKcclB712&index=4'],
    
    ['34,Video,How does this even happen,https://www.youtube.com/shorts/s0dU7oXtlbQ'],
    ['35,Video,So I went undercover to Indian Valorant...,https://www.youtube.com/watch?v=q5cecp--drU&list=PLm3rRjSsa9GbkmO-zwnjOu56gKcclB712&index=10'],
    ['36,Text,"Janta aaj mujhe GE se offer aaya hai team join karne ke liye as the sixth man. Par ghar waale bol rahe hain ki 10th boards ke liye padho yeh sab timepass mat karo. +918427601863 yeh mere papa ka number hai, unko sab log call karke samjhao ki mujhe khelne de GE ke liye. ",'],
    ['37,Photo,ASMR Unleashed,https://yt3.ggpht.com/8DZMemlnCNcTNxsHNKNDIZxtha9dYi6KJ3sjIQ5J5i75fj7sDQtwaj8g6lb7t-YRtFuVW4uw7UFz=s640-nd-v1'],
    ['38,Video,Hiko OP,https://www.youtube.com/shorts/9NMxQc5463k'],
    ['39,Photo,(●◡●),https://yt3.ggpht.com/pbSlxPapNFOuM5O15Y0CqOxKEX5tvTfKNswsa4K70I96XAMoFLgfF4-tTKLruLN7Wa048-CGLpBp=s800-nd-v1'],
    ['40,Video,THESE RANDOMS FOUGHT WITH EACH OTHER,https://www.youtube.com/watch?v=W2oJsZk56h8&list=PLm3rRjSsa9GbkmO-zwnjOu56gKcclB712&index=17'],
    ['41,Photo,Wise words,https://yt3.ggpht.com/r82LVGm3_EsHBa2EGsTSdk_8umFymjDPPpuZbAEbNCnzCjeEBIlK-L4sC1NfhvxyjThlhIT5bfy64Wk=s640-nd-v1'],
    ['42,Video,VALORANT.EXE,https://www.youtube.com/watch?v=SL4TDoC8mgg&list=PLm3rRjSsa9GbkmO-zwnjOu56gKcclB712&index=6'],
    ['43,Text,"Valorant ne mujhe jeena sikhaya. NO KIDDING. Shaadi tootne ke baad, papa ki death ho gayi aur mera civil service ka exam bhi fail ho gaya. Khudko maarne ke alawa aur kuch nahi soojhta tha. Par jab Valorant main Jett insta lockers ko bottom frag karte dekha toh laga ki hum itne bhi chutiye nahi hai. Thank you Valorant.",'],
    ['44,Photo,gamur!,https://yt3.ggpht.com/pQU3L8L6DdTuuMBs6XLPB94GqW5qY4WX74F05Omyj_RBGJDU7aw23VlLpiQgJfCc3QkyUd0ja2-JmQ=s800-nd-v1'],
    ['45,Video,Pro tier gameplay,https://www.youtube.com/watch?v=FCXRFAunWZg&list=PLm3rRjSsa9GbkmO-zwnjOu56gKcclB712&index=12'],
    ["46,Photo,Don't joke!,https://yt3.ggpht.com/j95iAp32Au4Oa5L7UVKPiL4rcoGxMoSh1uqMn5cizc-B9p_LpQPzdp28yj_B38fpA43eS97JSCGTDQ=s640-nd-v1"],
    ['47,Text,"Aaj meri mummy ne belan se mera PC tod diya yaar, toh maine bhi ghusse mein unke ek thappad laga diya. Ab mujhe ghar se nikaal diya hai papa ne aur mere phone mein sirf 2 percent battery bachi hai. Yaar tum logon mein se agar koi bhi Dhaula Kuan mein aake mujhe ek din apne wahan rakh sakte ho toh please help kardo meri. Canara bank ke just bahar hi khada hu mai.  '],
    ['48,Photo,Mysteries of the human mind,https://yt3.ggpht.com/F6twCZkPuU_tABYTl7W1RPgsI7SvyrDiAfNQEaVjyxsM9WfolLgMT6bfUtG6zhV1nI_XRr7aASOaUA=s640-nd-v1'],
    ['49,Video,Scream is not human,https://www.youtube.com/shorts/YItzHWBWlSw'],
    ['50,Photo,GG EZ,https://yt3.ggpht.com/qNv5G33g5ga5qZCijonfFh9MtNT5tky43ednFlbJJu2Yges7yw85zfo9L0TIeQiq9EqxJn-2rTxy=s640-nd-v1'],
    ['51,Video,Dank Indian Valorant,https://www.youtube.com/watch?v=rZKPWSiT5MQ&list=PLm3rRjSsa9GbkmO-zwnjOu56gKcclB712&index=11'],
    ['52,Text,Yaar koi kuch bhi kahe par mai toh hamesha ek sachhe feminist ban ke hi rehna chahta hu #equalrights,'],
    ['53,Photo,Inhe koi Nasha Mukti kendra le jaayein,https://yt3.ggpht.com/w6cxEq9q0LtC0NRN_1T28HmmM0qJZcx1CSwrBOWwQ-QtkAabCeRFnaxHFeSqBaZLjxZ6SYfOwoeZ=s640-nd-v1'],
    ['54,Video,cypher is FORGOTTEN by riot,https://www.youtube.com/watch?v=RpfkaUxBOIA&list=PLm3rRjSsa9GbkmO-zwnjOu56gKcclB712&index=13'],
    ['55,Photo,🤐,https://yt3.ggpht.com/qvysGUz0QdFyeSMsse2gZDhbVb36SU-_4dUc7yoJRBBdIOH1IixwyX0To8n4l13snKRKe0XJN6xq=s640-nd-v1'],
    ['56,Video,Sadge,https://www.youtube.com/shorts/VLRlnVJ6UYY'],
    ['57,Text,Kal aana kal. Kal aana kal. Kal aana kal. Kal aana kal. Kal aana kal. Kal aana kal. Kal aana kal. Kal aana kal. Kal aana kal. Kal aana kal. Kal aana kal. Kal aana kal. Kal aana kal. Kal aana kal. Kal aana kal. Kal aana kal.,'],
    ['58,Photo,Listen to your teachers,https://yt3.ggpht.com/wn9WkScn96KqZSlo8SBNN4DCv-7yPVlXq_e8wPx0-7lrgy87To9x-rNnf1lXZYn2ifLDNCLPL8FB=s640-nd-v1'],
    ['59,Video,How bad can VALORANT graphics really get?,https://www.youtube.com/watch?v=fzhNV4RNViM&list=PLm3rRjSsa9GbkmO-zwnjOu56gKcclB712&index=7'],
    ['60,Photo,Sticky key,https://yt3.ggpht.com/3qlYJs5y99AHNV4l4Qa0r9ABtCBqNhqAjlfaDEFUTS5fuQ1gLGs99ddBL-fTwb8azYivvX-Jzq_JcA=s640-nd-v1-rwa'],
    ['61,Video,Take it easy my man!,https://www.youtube.com/shorts/Skf9JSecU8s'],
    ['62,Photo,"""Get out of my way""",https://yt3.ggpht.com/zvX1kbDva5G-689nHJxiSuJMkZXIYaN9vrUzAwAEbW6ROwmJuDfsdEPud14u7LfWtqzi514uEpotV2w=s640-nd-v1-rwa'],
    ['63,Text,"I\'m looking to sell my PC Setup for Rs 65,000. It has 16gb ram, GTX 1650ti, Core i7 8th gen, 500gb SSD and 1TB HDD and also an 18 inch LG monitor. If anyone interested please DM on instagram, my handle is socketpowerlocket16.",'],
    ['64,Photo,Peek le naa,https://yt3.ggpht.com/rzn0V1CaLFH9ujGb8v7bmD6yzZeqB5vYrIjzAZCV9SPWA_nWtP7iqiW4y741T-ktgDNOrAfYo8f2=s791-nd-v1'],
    ["65,Video,Tbone's superchat challenge,https://www.youtube.com/watch?v=ywIho2rVErI&list=PLm3rRjSsa9GbkmO-zwnjOu56gKcclB712&index=16"],
    ['66,Photo,How is this possible!,https://yt3.ggpht.com/-cmOFmVXrcN9UgiKjnfXSururi2dSnSp_oQ3uXxulcEXBFizizpLXzI2_UdQvtudJIff2_buOxI2bw=s410-nd-v1-rwa'],
    ['67,Video,Sage wall strats,https://www.youtube.com/shorts/g6R9nvjRhfU'],
    ['68,Photo,Bhai ro mat please,https://yt3.ggpht.com/OYwfAOgH-dxAVhdhQpSJq51TQOIFA_18Krx3B5kNIBCYnaq7gULMYeqZKElJfBXlYJ7k7jMv1BIDYg=s640-nd-v1-rwa'],
    ['69,Video,The IRON World Cup — INDIA vs PHILIPPINES,https://www.youtube.com/watch?v=KH-NPSGeLSs&list=PLm3rRjSsa9GbkmO-zwnjOu56gKcclB712&index=15'],
    ['70,Text,"Aaj silver 1 se mai direct iron 2 pe aagaya hu, dimag kharab hora hai. kisi ko khelna hai kya thoda compi, mai sahi khelta hu bas teammates sahi chahiye?",'],
    ['71,Photo,Why you always lyin,https://yt3.ggpht.com/dA5HDIa8voNLkhnfaKHQ7T7sj2QVkkIdJj8G4mBBCeYr3J3UEyGbarRC-VQPg2Phk4cRsiXfcktb=s640-nd-v1-rwa'],
    ["1,Video,Don't be shy to try jumpshots!,https://www.youtube.com/watch?v=SOZDF2phcwE"],
    ['2,Video,i COMPLETELY broke FRACTURE!!,https://www.youtube.com/watch?v=037YkqSnzU0'],
    ["6,Video,MAKE YOUR OWN LINEUPS IF YOU DON'T KNOW ANY,https://www.youtube.com/watch?v=s0ewOozw3sc"],
    ['7,Video,Never seen movement like this!,https://www.youtube.com/watch?v=1vMXbGd_m6U'],
];


// install Swiper modules
SwiperCore.use([Pagination]);

const Mobile = styled.div`
  display: none;
  @media only screen and (max-device-width: 480px) {
    display: flex;
    height: 96vh;
    flex-direction: column;
  }
`;

const Desktop = styled.div`
  display: none;
  @media (min-device-width: 481px) {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
  }
`;

const Banner = styled.div`
  top: 0px;
  position: fixed;
  width: 100%;
  height: 123px;
`;

const LikeButton = styled.a`
    background: #000000;
    border: 2px solid #FE434C;
    box-sizing: border-box;
    border-radius: 42px;
    width: 100%;
    margin: 8px;
    text-align: center;
    padding: 16px;
    background: ${props => props.pressed ? "#FE434C" : "transparent"};
`;

const ShareButton = styled.a`
    background: #000000;
    border: 2px solid #A6FD53;
    box-sizing: border-box;
    border-radius: 42px;
    width: 100%;
    margin: 8px;
    text-align: center;
    padding: 16px;
`

const Jodd = styled.span`
    font-family: 'Poppins';
    font-style: normal;
    font-weight: bold;
    font-size: 38px;
    line-height: 13px;
    /* identical to box height, or 36% */

    display: flex;
    align-items: center;
    text-align: right;

    color: #FFFFFF;
    bottom: 24px;
    position: absolute;
    left: 26px;

`

export default function ClipPage(props) {
  
  

  const getImageContainer = (url) => {
      return (
          <img style={{marginTop: 8, width: '100%'}} src={url}/>
      )
  }

  const getVideoContainer = (url, title) => {
      let id;
      let height;
      if(url.includes('watch')) {
          id = url.split('watch?v=')[1];
          height = 400;
      } else {
          id = url.split('shorts/')[1];
          height = 700;
      }
    //   return(
    //     <div className='onq-youtube-player' style={{width: '100%', display: 'block', position: 'relative', cursor: 'pointer', height: height, overflow: 'hidden', margin: '20px 0'}} data-id={id} data-width='640' data-height='360' data-ssv='false' data-spc='false' data-sta='false' data-afs='false' data-dkc='false' data-ecc='false' data-eap='false'>
    //         <img src='//i.ytimg.com/vi/SOZDF2phcwE/hqdefault.jpg' style={{display: 'block', left: 0, margin: 'auto', width: '100%', height: '100%', position: 'absolute', right: 0}} />
    //         <div style={{height: 72, width: 72, left: '50%', top: '50%', marginLeft: -36, marginTop: -36, position: 'absolute', background: `url("https://www.onqmarketing.com.au/wp-content/plugins/onq-youtube-embed-generator/playbutton.png") no-repeat`, backgroundSize: 72}}></div>
    //     </div>
    //   );
    return (
        <iframe
            width="100%"
            height={height}
            src={`https://www.youtube.com/embed/${id}`}
            srcdoc={`<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style><a href=https://www.youtube.com/embed/${id}?autoplay=1&mute=0&controls=0&showinfo=0><img style="height=${height}" src=https://img.youtube.com/vi/${id}/hqdefault.jpg alt='${title}'><span>▶</span></a>`}
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            title={title}
            ></iframe>
    )
}

  const Card = ({item}) => {
      console.log(item)
      const props = item[0].split(',')
      let content;
      if(props[1] == 'Photo') {
        content = getImageContainer(props[3]);
      }
      if(props[1] == 'Video') {
          content = getVideoContainer(props[3], props[2])
      }
      const [pressed, setPressed] = useState(false);

      return (
        <div style={{paddingBottom: 32, borderBottom: '2px solid #313131', marginBottom: 20}}>
            <span style={{margin: 16, fontSize: 16, fontWeight: 'bold', marginBottom: 36}}>{props[2]}</span>
            {content}
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', marginTop: 8}}>
                <LikeButton onClick={() => setPressed(!pressed)} pressed={pressed}>like</LikeButton>
                <ShareButton onClick={() => navigator.share({url: 'glip.gg/meme', title: 'jodd app'})}>share</ShareButton>
            </div>
        </div>
      );
  };

  const cards = data.map((item, index) => {
      return <Card key={`card-${index}`} item={item}/>
  })

  return (
    <>      
      <Mobile>
        <Banner style={{background: `url(${meme_banner})`}}>
            <Jodd>
                jodd
            </Jodd>
        </Banner>
        <div style={{marginTop: 140}}>
            {cards}
        </div>
      </Mobile>
      <Desktop>
      <Banner style={{background: `url(${meme_banner})`}}></Banner>
      <div style={{marginTop: 130}}>
            {cards}
        </div>
      </Desktop>
    </>
  );
}

// module.exports = VideoPage;
